<template>
  <v-navigation-drawer
    v-model="show"
    right
    temporary
    fixed
    :width="drawerWidth"
    app
    class="drawer-quote d-flex flex-column"
    style="height: 100vh; overflow: hidden"
    @input="onDrawerToggle"
  >
    <div
      class="pa-4"
      ref="scrollContent"
      style="
        display: flex;
        flex-direction: column;
        overflow-y: auto;
        height: 100%;
      "
    >
      <v-card-title class="text-h4 d-flex align-center justify-center">
        <div>
          <!-- Cotizá materiales para tu proyecto -->
          Nueva cotización
        </div>
        <v-spacer></v-spacer>
        <v-btn icon medium @click="close" style="border: 1px solid #000">
          <v-icon medium color="#000">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider class="my-4"></v-divider>
      <v-card-text>
        <div class="mb-4">
          <div class="mb-5" style="font-size: 1.2rem">
            Hola, quiero cotizar los siguientes materiales:
          </div>
          <v-textarea
            class="material-textarea"
            v-model="quote.description"
            outlined
            no-resize
            label="Mi cotización"
            placeholder="Ej: Cemento gris 50kg, varilla de 3/8”, malla electrosoldada..."
            autofocus
            rows="8"
            @blur="onDescriptionBlur"
          ></v-textarea>
          <p>
            * Esta información se enviará a los proveedores de la red en base al
            tipo de material que buscas.
          </p>
        </div>

        <v-divider class="my-4"></v-divider>

        <v-card outlined>
          <v-card-text>
            <div v-if="!showPhone">
              <v-col cols="12" class="d-flex align-center justify-center">
                <v-icon medium class="mr-2">mdi-bell-outline</v-icon>
                <div>
                  Te <b>notificaremos por Whatsapp</b> al número:
                  <b>{{ $ProjectsManager.getQuotePhone() }}</b>
                </div>
              </v-col>
              <div class="text-center">
                <v-btn
                  x-small
                  rounded
                  dark
                  elevation="0"
                  @click="showPhone = true"
                  >Cambiar</v-btn
                >
              </div>
            </div>
            <div v-else>
              <v-col cols="12" class="d-flex align-center justify-center">
                <v-icon medium class="mr-1">mdi-bell-outline</v-icon>
                <div class="text-center font-weight-medium">
                  Ingresa el Whatsapp donde deseas recibir notificaciones.
                </div>
              </v-col>
              <v-text-field
                v-model="quote.phone"
                label="WhatsApp"
                prefix="+52"
                placeholder="+81 9999 8888"
                type="tel"
                inputmode="numeric"
                maxlength="10"
                outlined
                clearable
                @input="
                  quote.phone = quote.phone.replace(/\D/g, '').slice(0, 10)
                "
                :rules="[
                  (v) => !!v || 'Ingresa tu WhatsApp',
                  (v) => quote.phone.length === 10 || 'Debe tener 10 dígitos',
                ]"
                ref="phoneField"
              />
            </div>
          </v-card-text>
        </v-card>
        <v-card class="mt-2" outlined>
          <v-card-text>
            <div v-if="selectedProjectx.id">
              <v-col cols="12" class="d-flex align-center justify-center">
                <v-icon medium class="mr-2">mdi-domain</v-icon>
                <div>
                  Se asignara el proyecto:
                  <b>{{ selectedProjectx.name ?? "" }}</b>
                </div>
              </v-col>
              <div class="text-center">
                <v-btn
                  x-small
                  rounded
                  dark
                  elevation="0"
                  @click="resetselectedProjectx"
                  >Cambiar</v-btn
                >
              </div>
            </div>
            <div v-else>
              <v-col cols="12" class="d-flex align-center justify-center">
                {{ selectedProjectx.name }}
                <v-icon medium class="mr-2">mdi-domain</v-icon>
                <div class="text-center font-weight-medium">
                  Asignale un proyecto a esta cotización
                </div>
              </v-col>
              <v-autocomplete
                v-if="!selectedProjectx || !selectedProjectx.id"
                v-model="quote.project_id"
                :items="projects"
                item-text="name"
                return-object
                label="Seleccionar proyecto"
                placeholder="Buscá por nombre"
                outlined
                clearable
                :rules="[(v) => !!v || 'Seleccioná un proyecto']"
              />
            </div>
          </v-card-text>
        </v-card>
        <v-divider class="my-4"></v-divider>
        <div class="mt-5 project-form-buttons">
          <v-btn
            block
            outlined
            :class="{
              'btn-disabled': !isFormComplete || loading,
              'btn-enabled': isFormComplete && !loading,
            }"
            @click="handleSubmit"
            :disabled="!isFormComplete || loading"
          >
            <transition name="fade-text" mode="out-in">
              <span :key="buttonText">{{ buttonText }}</span>
            </transition>
          </v-btn>
        </div>
      </v-card-text>
    </div>
  </v-navigation-drawer>
</template>

<script>
import QuoteService from "@/services/quoteService";

export default {
  name: "DialogQuoteForm",

  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    // projects: [],
    projects: { type: Array, required: true },
    selectedProject: {
      type: Object,
      default: () => ({
        id: null,
        name: null,
        budget: null,
        address: null,
        start_date: null,
        type_id: null,
        phase_id: null,
      }),
    },
  },

  data() {
    return {
      quote: {
        name: "",
        project_id: {}, // <- no null
        description: "",
        phone: "",
      },
      show: this.visible,
      msgPreview: "",
      showPhone: false,
      selectedProjectx: { ...this.selectedProject },
      loading: false,
    };
  },

  computed: {
    isFormComplete() {
      const { description, phone, project_id } = this.quote;
      return !!description && !!phone && !!project_id;
    },

    drawerWidth() {
      return this.$vuetify.breakpoint.mdAndDown ? "100%" : "40%";
    },

    buttonText() {
      if (!this.isFormComplete) return "Completá todos los campos";
      return "Enviar cotización";
    },
  },
  methods: {
    async handleSubmit() {
      this.loading = true;
      this.quote.project_id =
        this.quote.project_id?.id || this.selectedProjectx.id;

      try {
        let response = null;
        response = await QuoteService.save(this.quote);

        if (response.ok) {
          this.updateQuotePhone(this.quote.phone);
          const result = await response.json();
          this.$emit("quoteUpdate", result.quote);
          this.close();
        }
      } catch (error) {
        console.error("Error al actualizar el proyecto");
      } finally {
        this.loading = false;
      }
    },

    onDrawerToggle(val) {
      if (!val) {
        this.close();
      }
    },

    close() {
      this.resetForm();
      this.$emit("close");
    },

    resetselectedProjectx() {
      this.selectedProjectx = {
        id: null,
        name: null,
        budget: null,
        address: null,
        start_date: "",
        type_id: null,
        phase_id: null,
      };
    },

    resetForm() {
      this.resetselectedProjectx();
      this.showPhone = true;
      this.quote.name = null;
      this.quote.project_id = {};
      this.quote.description = null;
      this.quote.phone = "";
    },

    scrollToBottom() {
      return new Promise((resolve) => {
        this.$nextTick(() => {
          const el = this.$refs.scrollContent;
          if (el) {
            el.scrollTo({ top: el.scrollHeight, behavior: "smooth" });
            setTimeout(resolve, 300);
          } else {
            resolve();
          }
        });
      });
    },

    // Cuando el textarea pierda foco:
    async onDescriptionBlur() {
      // 1) baja al final
      await this.scrollToBottom();
      // 2) enfoca el campo WhatsApp
      const phoneCmp = this.$refs.phoneField;
      if (phoneCmp) {
        // intenta enfocar el input interno
        const input = phoneCmp.$el.querySelector("input");
        input && input.focus();
      }
    },

    setQuotePhone() {
      const phone = this.$ProjectsManager.getQuotePhone();

      if (phone) {
        this.quote.phone = phone;
        this.showPhone = false;
        return;
      }

      this.showPhone = true;
    },

    updateQuotePhone(phone) {
      if (!phone) return;
      const phoneStorage = this.$ProjectsManager.getQuotePhone();

      if (phone != phoneStorage) {
        this.$ProjectsManager.setQuotePhone(phone);
      }
    },
  },

  watch: {
    visible(value) {
      this.show = value;

      if (value) {
        this.setQuotePhone();

        this.$nextTick(() => {
          setTimeout(() => {
            const el = this.$refs.scrollContent;
            if (el) el.scrollTop = 0;
          }, 100);
        });
      }

      if (!value) this.close();
    },

    selectedProject(newVal) {
      this.selectedProjectx = { ...newVal };
    },
  },
};
</script>

<style scoped>
.btn-disabled {
  background-color: #f2f2f2 !important;
  color: #999 !important;
  border-color: #ddd !important;
  cursor: not-allowed !important;
}

.btn-enabled {
  background-color: #1d1d1f !important;
  color: white !important;
  border-color: #1d1d1f !important;
}

.preview-quote {
  max-height: 100px;
  min-height: 100px;
  overflow-y: auto;
  overflow-x: hidden;
  white-space: pre-wrap;
  word-break: break-word;
  overflow-wrap: break-word;
  padding: 12px;
  font-size: 0.9em;
  font-family: monospace;
  background-color: #f5f5f5;
  /* border: 1px solid #ddd; */
  border-radius: 4px;
  box-sizing: border-box;
  max-width: 800px !important;
}

@media (max-width: 998px) {
  .project-form-buttons {
    padding-bottom: 30% !important;
  }
}
</style>
